;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Card, Row, Col, Button } from 'reactstrap';
import Link from 'next/link';
import CandidateHasNoAgency from './svg/CandidateHasNoAgency';
import { useParams } from 'next/navigation';
import { Dictionaries } from '../i18n/i18n-config';
import { getI18nUtils } from '../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
};
const NoAgencyTeaser = ({ dictionary }: Props) => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  return (
    <Card className="noAgencyTeaser h-100 p-4 mb-0 d-flex justify-content-center bg-light">
      <Row className="d-flex flex-column align-items-center">
        <Col className="d-flex justify-content-center mb-3">
          <CandidateHasNoAgency />
        </Col>
        <Col className="d-flex justify-content-center">
          <Link href={`/${locale}/my-synergie/edit-agency`}>
            <Button outline>{formatMessage({ id: 'choose_agency' })}</Button>
          </Link>
        </Col>
      </Row>
    </Card>
  );
};

export default NoAgencyTeaser;
